export class SummaryModel {
    status: string;
    reservationNo: string;
    language: string;
}
